/**
  DO NOT EDIT THIS FILE MANUALLY
  Generated by `Opus::Mkt::Tools::GenerateReactData`
  If this file is out-of-sync or causing builds to fail, try running `scripts/bin/remote-script ./mkt/Tools/generate_react_data.rb`
*/

import {Locales} from 'mkt-ssr/generated/globalization/locales';
import {Countries} from 'mkt-ssr/generated/globalization/countries';

export const AlternateLanguageDefaults = [
  {country: Countries.BR, locale: Locales.ptBr},
  {country: Countries.NL, locale: Locales.nlNl},
  {country: Countries.US, locale: Locales.enUs},
  {country: Countries.FR, locale: Locales.frFr},
  {country: Countries.DE, locale: Locales.deDe},
  {country: Countries.IT, locale: Locales.itIt},
  {country: Countries.JP, locale: Locales.jaJp},
  {country: Countries.SG, locale: Locales.zhHans},
  {country: Countries.ES, locale: Locales.esEs},
  {country: Countries.SE, locale: Locales.svSe},
  {country: Countries.TH, locale: Locales.thTh},
] as const;
